'use strict';

angular.module('atex.dam').factory('DamTemplateService', ['$q', 'ContentService', 'UIConfigurationService','ContentCacheService',
function($q, ContentService, UIConfigurationService, ContentCacheService) {

  var templates = [];
  var actTemplates = [];
  var createContentTemplates = [];

  var _getTemplateById = function(id) {
    for (var i = 0; i < templates.length; i++) {
      if (templates[i]['id'] === id) {
        return templates[i];
      }
    }
  };

  var _getTemplateByIdAndInputTemplate = function(id, inputTemplate) {
    var template;
    var templateFound = false;
    var inpuTemplateFound = false;
    for (var i = 0; i < templates.length; i++) {
      if (templates[i]['id'] === id) {
        template = templates[i];
        templateFound = true;
        var templateInputTemplate = atex.onecms.ObjectUtils.getByPath(template, 'aspects/contentData/data/inputTemplate');
        if (templateInputTemplate && templateInputTemplate === inputTemplate) {
          inpuTemplateFound = true;
          break;
        }
      }
    }
    if (templateFound && !inpuTemplateFound) {
      for ( i = 0; i < templates.length; i++) {
        if (templates[i]['type'] === id) {
          template = templates[i];
          templateFound = true;
          var templateInputTemplateType = atex.onecms.ObjectUtils.getByPath(template, 'aspects/contentData/data/inputTemplate');
          if (templateInputTemplateType && templateInputTemplateType === inputTemplate) {
            inpuTemplateFound = true;
            break;
          }
        }
      }
    }

    if (templateFound && !inpuTemplateFound) {
      console.error("InputTemplate NOT FOUND for template id '" + id + "' - and inputTemplate '" + inputTemplate + "'");
    }
    return template;
  };

  var _getTemplatesFor = function (content,preview,doNotCheckInputTemplate) {
    return _.filter(actTemplates, function (template) {
      var data = (content.data) ? content.data : content._data;
      var templateInputTemplate = atex.onecms.ObjectUtils.getByPath(template, 'aspects/contentData/data/inputTemplate');
      var entryInputTempate = atex.onecms.ObjectUtils.getByPath(data, 'aspects/contentData/data/inputTemplate');

      var matchInputTemplate = true;
      if (doNotCheckInputTemplate && doNotCheckInputTemplate[template.type]){
        matchInputTemplate = doNotCheckInputTemplate[template.type].includes(template.id);
      }else if(templateInputTemplate) {
        matchInputTemplate = (templateInputTemplate === entryInputTempate);
      }

      return typeof template.type !== 'undefined' && template.type === data.aspects.contentData.data._type && matchInputTemplate && (preview ? preview : (!template.id.endsWith('.preview') && !template.id.endsWith('.readonly')));
    });
  };

  var parseTemplateData = function(data) {
    return JSON.parse(data);
  };

  // ADMS-251: this is the old loading template function, we will use it
  // as a fallback in case the variant is not found.

  var recursiveTemplateLoad = function(transferInfo, templates, filter) {
    return ContentService.getContent(transferInfo).then(function (responseInfo) {
      var promises = responseInfo.data.aspects.contentData.data.templateList.map(function (contentId) {
        var transferInfo = {
          id: contentId.replace("contentid/", "")
        };
        return ContentService.getContent(transferInfo).then(function (responseInfo) {
          var template = parseTemplateData(responseInfo.data.aspects.contentData.data.data);
          if (typeof filter === 'undefined' || filter(template)) {
            templates.push(template);
          }
          return template;
        });
      });
      return $q.all(promises);
    }).then(null, function (error) {
      console.log('ERROR: Getting TemplateList:', error);
      return $q.reject(error);
    });
  };

  // ADMS-251: load the template list using a variant that automatically
  // fetches all the references templates.

  var loadTemplatesWithVariant = function(transferInfo, templates, filter) {
    return ContentCacheService.get (transferInfo.id, function () {
      return ContentService.getContent(_.extend({}, transferInfo, {variant: 'com.atex.gong.app.templates.list'}));
    })
    .then(function (responseInfo) {
        var bean = atex.onecms.ObjectUtils.getByPath(responseInfo, 'data/aspects/contentData/data');
        _.each(bean.templateList || [], function (t) {
          var template = parseTemplateData(t.data);
          if (typeof filter === 'undefined' || filter(template)) {
            templates.push(template);
          }
        });
        return templates;
      })
    .then(null, function (error) {
        var statusCode = atex.onecms.ObjectUtils.getByPath(error, 'rootCause/response/statusCode');

        // in case we got a "NOT_FOUND_IN_VARIANT" than we will
        // use the fallback function.

        if (statusCode === 40460) {
          return recursiveTemplateLoad(transferInfo, templates, filter);
        } else {
          return $q.reject(error);
        }
      }
    );
  };

  return {
    loadTemplates: function() {
      templates = [];
      var transferInfo = {id: 'p.onecms.DamTemplateList'};
      return loadTemplatesWithVariant(transferInfo, templates);
    },

    getTemplateById: function(id) {
      var deferred = $q.defer();
      var template = _getTemplateById(id);
      if (template || templates.length>0) {
        deferred.resolve(template);
      } else {
        // Load the templates from DB
        this.loadTemplates().then(function() {
          deferred.resolve(_getTemplateById(id));
        });
      }
      return deferred.promise;
    },

    getTemplateByIdAndInputTemplate: function(id, inputTemplate) {
      if (!inputTemplate) {
        return this.getTemplateById(id);
      }
      var deferred = $q.defer();
      var template = _getTemplateByIdAndInputTemplate(id, inputTemplate);
      if (template || templates.length>0) {
        deferred.resolve(template);
      } else {
        // Load the templates from DB
        this.loadTemplates().then(function() {
          deferred.resolve(_getTemplateByIdAndInputTemplate(id, inputTemplate));
        });
      }
      return deferred.promise;
    },

    loadActTemplates: function() {
      actTemplates=[];
      var transferInfo = {id: 'atex.onecms.ContributorToolTemplateList'};
      return loadTemplatesWithVariant(transferInfo, actTemplates);
    },

    loadCreateContentTemplates: function () {
      createContentTemplates = [];
      var transferInfo = {id: 'p.onecms.DamCreateContentTemplateList'};
      return loadTemplatesWithVariant(transferInfo, createContentTemplates, function(template) {
        return !template.hidden;
      });
    },

    getActTemplateFor : function (content,preview,doNotCheckInputTemplate) {
      var deferred = $q.defer();

      if (actTemplates.length>0) {
        deferred.resolve(_getTemplatesFor(content,preview,doNotCheckInputTemplate));
      } else {
        this.loadActTemplates().then(function() {
          deferred.resolve(_getTemplatesFor(content,preview,doNotCheckInputTemplate));
        });
      }
      return deferred.promise;
    },

    getFilteredTemplateFor: function (content) {
      var template;
      var createdWithTemplateId = content._data ?
        atex.onecms.ObjectUtils.getByPath(content, '_data/aspects/atex.OneCMS/data/createdWithTemplate') :
        atex.onecms.ObjectUtils.getByPath(content, 'data/aspects/atex.OneCMS/data/createdWithTemplate');
      // In case we found a valid template in the Desk available, let's return it
      if (createdWithTemplateId && createdWithTemplateId !== 'undefined') {
        var temp = _getTemplateById(createdWithTemplateId);
        if (temp) {
          return $q.when(temp);
        }
      }
      // Otherwise let's try to find it in the user templates
      return UIConfigurationService.filter("create-new", "desk-create-new", actTemplates).then(function (_templates) {
        if (typeof createdWithTemplateId !== 'undefined') {
          template = _.find(_templates, function (template) {
            return template.id === createdWithTemplateId;
          });
        }

        if (typeof template === 'undefined') {
          var _type = content._data ? content._data.aspects.contentData.data._type : content.data.aspects.contentData.data._type;
          template = _.find(_templates, function (template) {
            return typeof template.type !== 'undefined' && template.type === _type && !template.id.endsWith('.preview');
          });
        }

        return template;
      });
    }
  };
}]);
